export default "__VITE_ASSET__DlcLXeq3__"